import { ICrudLocale } from '@app/i18n/interface';

export const EXCHANGE_RATE_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  EXCHANGE_RATE: {
    LABEL: {
      SINGULAR: 'Tipo de cambio',
      PLURAL: 'Tipos de cambio',
    },
    FORM: {
      ADD_TITLE: 'Añadir tipo de cambio',
      EDIT_TITLE: 'Editar tipo de cambio',
      CARD_TITLE: 'Datos del tipo de cambio',
      BACK: 'Volver a Tipos de cambio',
      ADD_DESCRIPTION: 'Da de alta un par de divisas con su tasa y su margen.',
      EDIT_DESCRIPTION: 'Cambia la tasa, el margen o el estado. El par de divisas no se puede cambiar.',
      FETCH_ERROR: 'No hemos podido cargar el tipo de cambio. Vuelve a intentarlo.',
      SUBMIT_ERROR: 'Hay datos que revisar. Corrígelos y vuelve a intentarlo.',
      PAIR_IMMUTABLE_HINT: 'El par no se puede cambiar: para otro par, crea un tipo de cambio nuevo.',
    },
    APPLIES: {
      TITLE: 'Cuándo se aplica una tasa',
      BODY: 'Una tasa solo entra cuando el proveedor cotiza en una divisa distinta de la de venta. Si ya cotiza en la divisa de venta, no se convierte nada, aunque la fila siga activa aquí.',
      WINDOW: 'Conversiones aplicadas · últimos {{days}} días',
      NONE: 'de las {{priced}} tarifas tarificadas necesitaron conversión: el proveedor está cotizando en la divisa de venta, así que estas tasas no están tocando ningún precio.',
      SOME: 'de las {{priced}} tarifas tarificadas necesitaron conversión, así que su tasa y su margen sí entraron en el precio de venta.',
      NO_DATA: 'Todavía no hay búsquedas medidas en esta ventana.',
    },
    FIELD: {
      PAIR: 'Par',
      BASE: 'Divisa base (proveedor)',
      QUOTE: 'Divisa de venta',
      RATE: 'Tasa media',
      MARGIN_PCT: 'Margen (%)',
      SOURCE: 'Origen',
      ACTIVE: 'Activa',
      STATE: 'Estado',
      UPDATED_AT: 'Actualizada',
    },
    VALIDATION: {
      CURRENCY_PATTERN: 'Usa un código ISO 4217 de 3 letras (p. ej. EUR).',
      RATE_POSITIVE: 'La tasa debe ser un decimal mayor que 0.',
      MARGIN_PATTERN: 'Escribe un decimal igual o mayor que 0.',
    },
    REFRESH: {
      ACTION: 'Actualizar desde el BCE',
      DONE_TITLE: 'Tasas actualizadas',
      DONE_TEXT:
        'Referencias del {{feedDate}}: {{created}} pares nuevos y {{updated}} actualizados.',
      NOOP_TITLE: 'Ya estaban al día',
      NOOP_TEXT:
        'Las referencias del {{feedDate}} ya estaban aplicadas: ninguna tasa ha cambiado.',
      PARTIAL_TITLE: 'Actualizado con avisos',
      PARTIAL_TEXT:
        'Referencias del {{feedDate}}: {{created}} pares nuevos y {{updated}} actualizados. Sin tocar: {{skipped}}.',
      FAILED_TITLE: 'No se pudo leer el feed del BCE',
      FAILED_TEXT:
        'Las tasas vigentes no se han modificado. Vuelve a intentarlo; la actualización diaria lo reintenta por su cuenta.',
    },
    LIST: {
      TITLE: 'Pares de divisas',
      DESCRIPTION: 'Tasas de referencia del BCE y su margen. Se actualizan solas cada día laborable.',
      ADD: 'Añadir tipo de cambio',
      CAPTION: 'Tipos de cambio por par de divisas',
      EMPTY: 'Todavía no hay ningún tipo de cambio.',
      ACTIVE: 'Activa',
      INACTIVE: 'Desactivada',
      EDIT: 'Editar',
      EDIT_ARIA: 'Editar el par {{pair}}',
      DISABLE: 'Desactivar',
      DISABLE_ARIA: 'Desactivar el par {{pair}}',
      ENABLE: 'Activar',
      ENABLE_ARIA: 'Activar el par {{pair}}',
    },
  },
};
